
import React, { Component } from "react";

import { BsyDashUtils } from '../../../utils/DashUtils';
// import { BsyConfig } from '../../../global/BsyConfig'
import './index.css';
import { BsyUtils } from "../../../utils/Utils";
import { BsyConfig } from "../../../global/BsyConfig";

export default class BsyDashBase extends Component {

    // constructor(props) {
    //     super(props)


    // }

    componentDidCatch(error, errorInfo) {
        console.error(error, errorInfo);
        // Catch errors in any components below and re-render with error message
        // this.setState({
        //   error: error,
        //   errorInfo: errorInfo
        // })
        // You can also log error messages to an error reporting service here
    }


    componentDidMount() {

        if (this.props.getContext) {
            this.props.getContext(this);
        }

        this.loadWidget()
    }

    loadWidget = (n, d) => {

        this.loadData && this.loadData(n, d);
    }

    _renderStyles = (dashStyles, styles, arg) => {

        dashStyles = dashStyles || this.props.dashStyles;
        // this.props.dashStyles = dashStyles;
        styles = styles || this.props.styles;
        // this.props.styles = styles;
        BsyUtils.applyFunc(this, this.props.onRenderBackground, styles, !0)
        let style = BsyDashUtils().getDashStylesExtendStyles(dashStyles, styles)

        this.palette = this.props.palette;
        // console.log('palette1', this.palette)
        // console.log('style', this.style)
        if (style) {
            if (style.theme && style.theme.palette) {
                if (this.palette === "default" || !this.palette) {
                    this.palette = style.theme.palette;
                }
            }
        }
        // console.log('palette2', this.palette)


    }

    // _parseFieldLabelFormat = (e) => {
    //     let i = [];
    //     BsyUtils.forEach(e, function (e, a) {
    //         let n = { ...a }
    //         BsyUtils.isNull(n.text) && (n.text = a.title)
    //         if ("subform" === a.type) {
    //             let s = [];
    //             BsyUtils.forEach(a.items, function (e, i) {
    //                 let a = { ...i }
    //                 BsyUtils.isNull(a.text) && (a.text = i.title)
    //                 s.push(a)
    //             })
    //             n.items = s
    //         }
    //         i.push(n)
    //     })
    //     return i
    // }
    _parseFieldLabelFormat = (e, orgds) => {

        function findField(name) {
            var tag = {};
            BsyUtils.forEach(orgds, (index, data) => {
                if (data.widget.widgetName == name) {
                    tag = { ...data.widget };
                }
            })
            return tag
        }

        var i = [];
        BsyUtils.forEach(e, (e, a1) => {
            var n = {};
            if (!orgds) {
                n = { ...a1 };
            } else {
                if (a1.type == 'linkquery') {
                    n = { ...a1, ...findField(a1.name) };
                } else {
                    n = { ...a1 };
                }
            }
            if (BsyUtils.isNull(n.text) && (n.text = a1.title),
                "subform" === a1.type) {
                var s = [];
                BsyUtils.forEach(a1.items, function (e, i) {
                    var a = { ...i };
                    BsyUtils.isNull(a.text) && (a.text = i.title)
                    s.push(a)
                })
                n.items = s
            }
            i.push(n)
        })
        return i
    }

    getFilterData = (t) => {
        let e = this.props
            , i1 = BsyUtils.applyFunc(this, e.onDataFilter, [], !1)
            , a = [];
        let i = i1.filter;
        this.filterMap = i1.filterMap;
        i && (a = a.concat(i))
        BsyUtils.isObjectEmpty(t) || (a = a.concat(t))
        e.filter && "visit" !== e.mode && (a = a.concat(e.filter.cond))
        return BsyUtils.isObjectEmpty(a) ? {} : {
            cond: a,
            rel: i1.rel || BsyConfig().CONST.FILTER_RELATION.AND
        }
    }

    _setFilterParam = (t) => {
        BsyUtils.isNull(t) || (this.filterParam = t)
    }
}